// @ts-nocheck
import { message } from "antd";
import { graphql } from '@apollo/client/react/hoc';
import { REWARD_REDEEM_MUTATION } from "./rewardSubscription.gql";

export const withRedeemPoint = Component =>
  graphql(REWARD_REDEEM_MUTATION, {
    props: ({ mutate, history }) => ({
      redeemPoints: async values => {
        try {
          const {
            data: { createRedeemPoint }
          } = await mutate({
            variables: {
              ...values
            }
          });
          message.destroy();
          return createRedeemPoint;
        } catch (e) {
          message.destroy();
          message.error("Couldn't perform the action");
          console.error(e);
        }
      }
    })
  })(Component);